export const getPlayerNextPolicy = (player) => {
  return player.nextPolicy && player.policy?.id !== player.nextPolicy.id ?
    player.nextPolicy : null;
};
